import React, {useContext, useEffect, useState} from "react";
import FilterContext from "../Context/FilterContext";
import cx from "classnames";
import Content from "./Content";

const Filters = props => {
    const {showFilters, setShowFilters} = useContext(FilterContext)
    const [translateY, setTranslateY] = useState(document.documentElement.clientHeight)

    function close() {
        setShowFilters(false)
        setTranslateY(document.documentElement.clientHeight)
    }

    function open() {
        setShowFilters(true)
    }

    useEffect(() => {
        window.addEventListener('resize', close)

        return () => {
            window.removeEventListener('resize', close)
        }
    }, [])

    return (
        <div className={'fixed z-40 inset-0 flex items-center justify-center pointer-events-none'}>
            <div onClick={close}
                 className={
                     cx('fixed inset-0 bg-gray-800 transition transform duration-1000', {
                         'opacity-0': !showFilters,
                         'opacity-50 pointer-events-auto': showFilters,
                     })}
            />
            <div onClick={event => event.stopPropagation()}
                 style={{
                     maxHeight: '90%',
                     transform: 'translateY(' + (showFilters ? 0 : translateY) + 'px)'
                 }}
                 className={'relative w-full max-w-3xl bg-white rounded-xl p-4 select-none overflow-y-auto my-16 pointer-events-auto transition transform duration-1000'}
            >
                <Content {...props}/>
            </div>
        </div>
    )
}

export default Filters